<script>
import { BLink } from 'bootstrap-vue'

export default {
    components: {BLink},
    props: {
        component: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    computed: {
        parents() {
            return this.component.parents.slice(1);
        },
        length() {
            return this.component.parents.length - 1;
        }
    }
}
</script>

<template>
    <ul class="list-group p-0 list-unstyled list-group-horizontal">
        <li v-for="(parent, index) in parents">
            <b-link
                :to="{ name: 'product-card', params: { id: parent.id }}"
            >
                {{ parent.title }}
                <span v-if="length === (index+1) && component.component.supplier">
                    from {{ component.component.supplier.title }}
                </span>
            </b-link>
            <feather-icon
                v-if="(index + 1) < length"
                size="18" style="margin: 0 8px 0 4px" icon="ChevronRightIcon"
            />
        </li>
    </ul>
</template>
